module.exports = __webpack_public_path__ + "img/3.9f776403.png";